import { render } from "./CaiGou.vue?vue&type=template&id=9a27d5b4"
import script from "./CaiGou.vue?vue&type=script&lang=js"
export * from "./CaiGou.vue?vue&type=script&lang=js"

import "./CaiGou.vue?vue&type=style&index=0&id=9a27d5b4&lang=less"

import exportComponent from "D:\\fxwl\\wx-wl_full\\wx-wl_full\\fxwl\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__